import clsx from "clsx";

import { type AccountingMode, AccountingModes } from "@north-beam/nb-common";
import { Button } from "@shared/buttons/button";

interface Props {
  isDisabled?: boolean;
  accountingMode: AccountingMode;
  confirmChangingAccountingMode: (mode: AccountingMode) => void;
}

export const AccountingModeSelector = ({
  isDisabled,
  accountingMode,
  confirmChangingAccountingMode,
}: Props) => {
  return (
    <div className="mb-2 pr-2">
      <div
        className={clsx("text-xs font-medium tracking-wide mb-1 pt-0.5", {
          "text-disabled": isDisabled,
          "text-interstellar+2": !isDisabled,
        })}
      >
        ACCOUNTING MODE
      </div>
      {AccountingModes.values.map((mode, index) => {
        return (
          <Button
            key={mode}
            disabled={isDisabled}
            variant={mode === accountingMode ? "primary" : "secondary"}
            className={clsx(
              "h-8 py-0 outline-none border border-gray-1 capitalize font-normal",
              {
                "rounded-s-md rounded-e-none border-r-0": index === 0,
                "rounded-e-md rounded-s-none":
                  index === AccountingModes.values.length - 1,
                "border-none": mode === accountingMode,
              },
            )}
            onClick={() => confirmChangingAccountingMode(mode)}
          >
            {mode}
          </Button>
        );
      })}
    </div>
  );
};
